import React, { useMemo } from 'react'
import { Table, MobileTable } from '../../../components'
// import makeData from '../makeData'

const data = [
  {
    id: 1,
    name: 'R.M Dewo Broto Joko P., SH, LLM',
    organization: 'BAPPENAS',
    phone: '085612341234',
    email: 'rmdewo@email.com',
  },
  {
    id: 2,
    name: 'Prof. Dr. Jamhari, M.A',
    organization: 'Convey Indonesia',
    phone: '081263221234',
    email: 'prof.jamhari@email.com',
  },
  {
    id: 3,
    name: 'Irfan Amali',
    organization: 'Peacegen Indonesia',
    phone: '089332143214',
    email: 'irfanamali@email.com',
  }
]

const FocalPoint = () => {
  const tableData = useMemo(() => data/* makeData(47) */, [])
  const tableColumns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Organization',
        accessor: 'organization',
      },
      {
        Header: 'Phone',
        accessor: 'phone',
      },
      {
        Header: 'Email',
        accessor: 'email',
      },
    ],
    []
  )

  return (
    <div>
      {/* Desktop Table */}
      <div className="hidden lg:block mb-12">
        <Table
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>

      {/* Mobile Table */}
      <div className="lg:hidden mobile-fullwidth mb-12">
        <MobileTable
          data={tableData}
          columns={tableColumns}
          withCheckbox
        />
      </div>
    </div>
  )
}

export { FocalPoint }
